declare global {
  interface Window {
    __magicLinkToken?: string;
  }
}

// Set by the first script in public/index.html, which also removes the token from the URL.
// Cleared here so the token does not stay readable on `window` after the app has it.
const token = window.__magicLinkToken ?? '';
delete window.__magicLinkToken;

export const getMagicLinkToken = () => token;
